 <template>
  <div class="full-height">
    <amf-form title="Nacha and ACH Payments" class="container">
      <div class="reports-view full-height flex-column">
        <ul class="nav nav-tabs">
          <li v-for="tab in tabs" :key="tab.id" class="nav-item">
            <a
              class="nav-link"
              href="#"
              @click.prevent="select(tab.id)"
              :class="{ active: tab.active }"
            >{{tab.title}}</a>
          </li>
        </ul>

        <div class="full-height">
          <div v-for="tab in tabs" :key="tab.id" class="full-height mt-3" v-show="tab.active">
            <div class="full-height" :is="tab.component" :type="tab" ></div>
          </div>
        </div>
      </div>
    </amf-form>
  </div>
</template>

<script>
import NachaList from './NachaList';
import HsaPushList from './HsaPushList';
import CheckFundedList from './CheckFundedList';

export default {
   components: {
    NachaList,
    HsaPushList,
    CheckFundedList
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    ...amfx.map("nachas", ["bankAccounts"]),
    tabs() {
      var result = [];
      if (this.can.viewParticipant) {

        this.bankAccounts.forEach(b=> {
          result.push({
              id: b.nachaType,
              component: "nachaList",
              title: this.tabTitle(b),
              bankAccount: b,
              direction: b.direction
          });
        });

        result.push({
              id: this.bankAccounts.length + 1,
              component: "hsaPushList",
              title: `HSA Push`,
          });

        result.push({
              id: this.bankAccounts.length + 2,
              component: "checkFundedList",
              title: `Standard Funding`,
          });

        if(result.length <= 0) return null;

        if(this.tab) {
          var a = result.find(a => a.id == this.tab);
          if(a) {
            a.active = true;
            return result;
          }
        }

        result[0].active = true;

        return result;
    }
   }
  },
  methods: {
    ...amfx.map("nachas", "loadBankAccountTypes"),
    select(tabId) {
       this.tab = tabId;
       this.$router.replace(`/nacha/${tabId}`);
    },
    load()
    {
       this.loadBankAccountTypes();
       this.tab = this.$route.params.payType;  
    },
    tabTitle(b)
    {
       if(b.nachaType == 4) return 'HSA Pull';
       return `${b.name} (${b.direction == 0 ? 'Deposit':'Debit'})`
    }
  },
  created()
  {
    this.load();
  }
};
</script>


// WEBPACK FOOTER //
// src/finance/Nacha.vue